import { render, staticRenderFns } from "./RegisterGoogle.vue?vue&type=template&id=5da54d7c&"
import script from "./RegisterGoogle.vue?vue&type=script&lang=js&"
export * from "./RegisterGoogle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports